(function () {
  function initHeaderSearch(wrapper) {
    const scope = wrapper.dataset.scope;
    const input = wrapper.querySelector('.header-search__input');
    const clearBtn = wrapper.querySelector('.header-search__clear');
    const panel = wrapper.querySelector('.header-search__dropdown');

    if (!input || !panel) return;

    let debounceTimer;
    let currentController;
    let currentQuery = '';
    let hasCurrentResults = false;

    function matchesScope(item) {
      if (Array.isArray(item.tags) && item.tags.some(t => t.toLowerCase() === scope)) {
        return true;
      }
      if (item.handle && item.handle.endsWith('-' + scope)) {
        return true;
      }
      return false;
    }

    function formatPrice(cents) {
      const a = (Number(cents) / 100).toFixed(2);
      return window.Shopify && window.Shopify.currency
        ? `${window.Shopify.currency.active} ${a}`
        : `$${a}`;
    }

    function escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function openPanel() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function closePanel() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function showLoading() {
      panel.innerHTML = `<div class="header-search__loading"><div class="header-search__spinner"></div></div>`;
      openPanel();
    }

    function showNoResults(query) {
      hasCurrentResults = false;
      panel.innerHTML = `<p class="header-search__no-results">No results for &ldquo;${escapeHtml(query)}&rdquo;</p>`;
      openPanel();
    }

    function renderResults(query, products, articles, pages) {
      if (!products.length && !articles.length && !pages.length) {
        showNoResults(query);
        return;
      }
      hasCurrentResults = true;

      let html = '<div>';

      if (products.length) {
        html += `
          <div class="header-search__section">
            <p class="header-search__section-title">Products</p>
            <ul class="header-search__products">`;
        products.forEach(p => {
          const imgSrc = p.image ? `${p.image}&width=72&height=72&crop=center` : '';
          html += `
            <li>
              <a href="${p.url}" class="header-search__product">
                <div class="header-search__product-img">
                  ${imgSrc
                    ? `<img src="${imgSrc}" alt="${escapeHtml(p.title)}" width="72" height="72" loading="lazy">`
                    : `<div class="header-search__product-img--placeholder">
                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
                       </div>`}
                </div>
                <div class="header-search__product-info">
                  <p class="header-search__product-title">${escapeHtml(p.title)}</p>
                  ${p.price ? `<p class="header-search__product-price">${p.price} ${Shopify.currency.active}</p>` : ''}
                </div>
              </a>
            </li>`;
        });
        html += `</ul></div>`;
      }

      if (articles.length) {
        html += `
          <div class="header-search__section header-search__section--secondary">
            <p class="header-search__section-title">Articles</p>
            <ul class="header-search__list">`;
        articles.forEach(a => {
          html += `
            <li>
              <a href="${a.url}" class="header-search__list-item">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                <span>${escapeHtml(a.title)}</span>
              </a>
            </li>`;
        });
        html += `</ul></div>`;
      }

      if (pages.length) {
        html += `
          <div class="header-search__section header-search__section--secondary">
            <p class="header-search__section-title">Pages</p>
            <ul class="header-search__list">`;
        pages.forEach(p => {
          html += `
            <li>
              <a href="${p.url}" class="header-search__list-item">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                <span>${escapeHtml(p.title)}</span>
              </a>
            </li>`;
        });
        html += `</ul></div>`;
      }

      html += `
        <div class="header-search__footer">
          <a href="/search?q=${encodeURIComponent(query)}&filter.p.tag=${scope}" class="header-search__view-all">
            View all results for &ldquo;${escapeHtml(query)}&rdquo;
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </a>
        </div>
      </div>`;

      panel.innerHTML = html;
      openPanel();
    }

    let searchRequestId = 0;

      async function runSearch(query) {
        const requestId = ++searchRequestId;

        if (currentController) currentController.abort();
        currentController = new AbortController();

        showLoading();

        try {
          const res = await fetch(
            `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,article,page&resources[limit]=20`,
            { signal: currentController.signal }
          );

          if (!res.ok) return;

          const data = await res.json();

          // Ignore stale responses
          if (requestId !== searchRequestId) return;

          const r = data.resources.results;

          const products = (r.products || []).filter(matchesScope);
          const articles = (r.articles || []).filter(matchesScope);
          const pages = (r.pages || []).filter(matchesScope);

          renderResults(query, products, articles, pages);
        } catch (err) {
          if (err.name !== 'AbortError') {
            console.error('Header search error:', err);
          }
        }
      }

    input.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      currentQuery = input.value.trim();
      clearBtn.style.display = input.value.length > 0 ? '' : 'none';

      if (currentQuery.length < 2) {
        closePanel();
        panel.innerHTML = '';
        hasCurrentResults = false;
        return;
      }

      debounceTimer = setTimeout(() => runSearch(currentQuery), 300);
    });

    input.addEventListener('focus', () => {
      if (panel.innerHTML.trim() !== '') openPanel();
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (currentQuery && hasCurrentResults) {
          window.location.href = `/search?q=${encodeURIComponent(currentQuery)}&filter.p.tag=${scope}`;
        }
      }
      if (e.key === 'Escape') {
        closePanel();
        input.blur();
      }
    });

    clearBtn.addEventListener('click', () => {
      input.value = '';
      currentQuery = '';
      hasCurrentResults = false;
      clearBtn.style.display = 'none';
      closePanel();
      panel.innerHTML = '';
      input.focus();
    });

    document.addEventListener('click', (e) => {
      if (!wrapper.contains(e.target)) closePanel();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.header-search[data-scope]').forEach(initHeaderSearch);

    /* ── Mobile search trigger: slides #mobile-search down — UNCHANGED ── */
    const trigger = document.getElementById('mobile-search-trigger');
    const search = document.getElementById('mobile-search');
    const input = search?.querySelector('.header-search__input');

    if (trigger && search) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        search.classList.add('active');
        setTimeout(() => { input?.focus(); }, 100);
      });

      document.addEventListener('click', function (e) {
        if (!search.contains(e.target) && !trigger.contains(e.target)) {
          search.classList.remove('active');
        }
      });
    }

    /* ── Mobile mega menu inner dropdowns — UNCHANGED ── */
    const innerToggles = document.querySelectorAll('.custom-header__dropdown--mobile .custom-header__menu-link--parent');
    innerToggles.forEach(button => {
      button.addEventListener('click', e => {
        e.preventDefault();
        const panelId = button.getAttribute('aria-controls');
        const panel = document.getElementById(panelId);
        if (!panel) return;
        const isOpen = panel.classList.toggle('is-open');
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    const mainNav = document.querySelector('.custom-header__nav--mobile');
    if (mainNav) {
      const observer = new MutationObserver(() => {
        if (mainNav.getAttribute('aria-hidden') === 'true') {
          innerToggles.forEach(btn => {
            const panelId = btn.getAttribute('aria-controls');
            const panel = document.getElementById(panelId);
            if (panel) panel.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
          });
        }
      });
      observer.observe(mainNav, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
  });
})();